import React, { useEffect, useState, lazy } from "react";
import MenuLayouts from "../layouts/menu.layout";
import BannerComponent from "../components/home/banner.component";
import FooterLayouts from "../layouts/footer.layout";
import {
  HomeBanner,
  HomeCallToAction,
  HomePortafolio,
  MetaData,
} from "../components/conexion/home.conexion";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import { lastNewsforCategories } from "../components/conexion/blogs.conexion";
import LazyPortafolio from "../Lazy/home/portafolio.lazy";
import LazyBlog from "../Lazy/home/blog.lazy";
import LazyOther from "../Lazy/home/other_page.lazy";
import LazySuscribe from "../Lazy/home/suscribe.lazy";
import { useLocation } from "react-router-dom";

const HomePage: React.FC = () => {
  const [dataBanner, setDataBanner] = useState([]);
  const [dataPortafolio, setDataPortafolio] = useState([]);
  const [dataCallToAction, setDataCallToAction] = useState([]);
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [newsForCategories, setNewsForCategories]: any = useState([]);
  const [meta, setMeta]: any = useState(null);
  const location = useLocation();

  /* useEffect(() => {
    const fetchMetaData = async () => {
      try {
        const res = await MetaData(location.pathname);
        console.log("Metadata cargada:", res.data.data[0]);
        setMeta(res.data.data[0]);
      } catch (error) {
        console.error("Error cargando metadatos:", error);
      }
    };

    fetchMetaData();
  }, []); // 👈 Se ejecuta cada vez que cambia la URL */

  // 1) Primer efecto: carga SOLO el banner
  useEffect(() => {
    const controller = new AbortController();

    const fetchBannerData = async () => {
      try {
        const res = await HomeBanner(); // ← Un solo llamado a HomeBanner
        setDataBanner(res.data.data);
      } catch (error: any) {
        if (error.name !== "AbortError") {
          console.error("Error cargando banner:", error);
        }
      }
    };

    fetchBannerData();

    return () => controller.abort(); // Cancela la petición si se desmonta
  }, []);

  // 2) Segundo efecto: carga lo demás (sin volver a llamar a HomeBanner)
  useEffect(() => {
    const controller = new AbortController();

    const fetchOtherData = async () => {
      try {
        // Llamamos en paralelo a las demás APIs
        const [portafolioRes, callToActionRes, newsRes] = await Promise.all([
          HomePortafolio(),
          HomeCallToAction(),
          lastNewsforCategories(),
        ]);

        setDataPortafolio(portafolioRes.data.data);
        setDataCallToAction(callToActionRes.data.data);

        // Armar la data de blogs
        let posts: any = [];
        newsRes?.data?.data[0].Categories.forEach((element: any) => {
          element.posts.forEach((pos: any) => {
            pos.category_id = element.category_id;
            pos.category = element.category;
            posts.push(pos);
          });
        });

        // Ordenar por fecha descendente
        const sortedPosts = posts.sort(
          (a: any, b: any) =>
            new Date(b.creation_datetime).getTime() -
            new Date(a.creation_datetime).getTime()
        );
        setNewsForCategories(sortedPosts.slice(0, 3));
      } catch (error) {
        console.error("Error cargando datos:", error);
      }
    };

    fetchOtherData();

    return () => controller.abort();
  }, []);

  return (
    <>
      {" "}
      <MenuLayouts
        className="home-page"
        active=""
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div className="home-page">
        <div className="home-page-mascara"></div>

        {/* El Banner ya tiene la data cargada por el primer efecto */}
        <BannerComponent dataBanner={dataBanner} />

        {/* Resto de secciones, con data cargada por el segundo efecto */}
        <LazyPortafolio portafolios={dataPortafolio} />
        <LazyBlog newsForCategories={newsForCategories} />
        <LazyOther callToAction={dataCallToAction} />
        <LazySuscribe />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default HomePage;
